import Accordian from "../../Components/scvpu/rsaDashboard/Accordian";
import ServiceRevenuePenetration from "./ServiceCollabaxStatics/ServiceRevenuePenetration";
import serviceRevenuePenetration from "../../Artifacts/scvpu/rsmDashboard/service_revenue_penetration_img.svg";
import dealerProfitablity from "../../Artifacts/scvpu/rsmDashboard/dealer_profitability.svg";
import serviceQuality from "../../Artifacts/scvpu/rsmDashboard/service_quality.svg";
import DealerProfitibility from "./ServiceCollabaxStatics/DealerProfitibility";
import ZoneCard from "./ServiceCollabaxStatics/ZoneCard";
import DealerService from "./ServiceCollabaxStatics/DealerQuality";

const ZoneDashboard = () => {
  return (
    <div className="overflow-x-hidden">
      <div className="w-full max-w-full ">
        <div className="pb-2">
          <ZoneCard />
        </div>

        <div className="flex flex-col gap-6">
          <Accordian
            icon={serviceRevenuePenetration}
            title="Service Revenue Penetration"
          >
            <ServiceRevenuePenetration />
          </Accordian>
          <Accordian
            icon={dealerProfitablity}
            title="Dealer Profitability (SAR improvement)"
          >
            <DealerProfitibility />
          </Accordian>
          <Accordian icon={serviceQuality} title="Service Quality">
            <DealerService />
          </Accordian>
        </div>
      </div>
    </div>
  );
};

export default ZoneDashboard;
